export default __webpack_public_path__ + "static/slide7-mobile-cfeffa0b057208f72133462e2e6430df.png";